import apiClient from './apiClient';

class ExcalidrawService {
  async saveSketch(content, noteId = null) {
    try {
      // Authentication is handled by interceptor based on skipAuth
      // Guests might need specific handling if backend doesn't assume guest
      const skipAuth = !localStorage.getItem('access_token'); // Example check
      
      //console.log(`Saving sketch with note_id: ${noteId}`);
      
      const requestBody = {
        content,
        note_id: noteId || null,
      };
      
      //console.log("POST request body:", JSON.stringify(requestBody, null, 2));
      
      const response = await apiClient.post('/draw/excalidraw/save', requestBody, skipAuth);
      
      //console.log("Sketch saved successfully:", response);
      return response;
    } catch (error) {
      console.error('Error saving Excalidraw sketch:', error);
      throw error;
    }
  }

  async updateSketch(uniqueId, content, noteId = null) {
    try {
      // Authentication is handled by interceptor
      const skipAuth = !localStorage.getItem('access_token'); // Example check
      
      //console.log(`Updating sketch ${uniqueId} with note_id:`, noteId);
      
      // Ensure note_id is explicitly null if undefined
      const formattedNoteId = noteId || null;
      
      const requestBody = {
        content,
        note_id: formattedNoteId
        // Backend infers user_id from token
        // If guest updates are possible, backend needs logic for that
      };
      
      //console.log("PUT request body:", JSON.stringify(requestBody, null, 2));
      
      const response = await apiClient.put(`/draw/excalidraw/${uniqueId}`, requestBody, skipAuth);
      
      //console.log(`Sketch ${uniqueId} updated successfully:`, response);
      return response;
    } catch (error) {
      console.error(`Error updating Excalidraw sketch with ID ${uniqueId}:`, error);
      throw error;
    }
  }

  async getSketch(uniqueId) {
    try {
      // Always allow retrieving sketches without auth
      // This enables public sharing of sketches
      const response = await apiClient.get(`/draw/excalidraw/${uniqueId}`, {}, true);
      return response;
    } catch (error) {
      console.error(`Error fetching Excalidraw sketch with ID ${uniqueId}:`, error);
      throw error;
    }
  }
  
  async getPublicSketches() {
    try {
      // Get publicly available sketches
      const response = await apiClient.get('/draw/excalidraw/public', {}, true);
      return response;
    } catch (error) {
      console.error('Error fetching public Excalidraw sketches:', error);
      throw error;
    }
  }
  
  async getUserSketches(userId) {
    // This method might still be needed if you want to get sketches for *other* users
    // Or if backend needs user_id explicitly for this GET endpoint
    try {
      // Get sketches for a specific user
      const response = await apiClient.get(`/draw/excalidraw/user/${userId}`);
      return response;
    } catch (error) {
      console.error(`Error fetching sketches for user ${userId}:`, error);
      throw error;
    }
  }
}

const excalidrawServiceInstance = new ExcalidrawService();
export default excalidrawServiceInstance; 